export const errorCodeTranslator = (errorCode: number): string =>
    errorCodeToMessage.find((codeKey: ICodeKey) => codeKey.code === errorCode)?.key;

export const errorCodeToMessage: ICodeKey[] = [
    { code: 400, key: 'ERRORS.HTTP.CODES.400' },
    { code: 401, key: 'ERRORS.HTTP.CODES.401' },
    { code: 403, key: 'ERRORS.HTTP.CODES.403' },
    { code: 404, key: 'ERRORS.HTTP.CODES.404' },
    { code: 408, key: 'ERRORS.HTTP.CODES.408' },
    { code: 422, key: 'ERRORS.HTTP.CODES.422' },
    { code: 500, key: 'ERRORS.HTTP.CODES.500' },
    { code: 502, key: 'ERRORS.HTTP.CODES.502' },
];

export interface ICodeKey {
    code: number;
    key: string;
}

export const errorMessageTranslator = (errorMessage: string): string =>
    errorMessageToMessage.find((messageKey: IMessageKey) => messageKey.code === errorMessage)?.key;

export const errorMessageToMessage: IMessageKey[] = [{ code: 'Le login est incorrect', key: 'ERRORS.HTTP.MESSAGES.INCORRECT-LOGIN' }];

export interface IMessageKey {
    code: string;
    key: string;
}
